import React, { FC, useState } from 'react';
import { ReactComponent as ArrowUpIcon } from 'assets/icons/gray-arrow-up-icon.svg';
import { OrderBrandMeal } from 'models/order.model';

type AccordionType = {
  item: OrderBrandMeal;
  defaultOpen?: boolean;
};

const MealAccordion: FC<AccordionType> = ({ defaultOpen = true, item }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className='pb-5'>
      <div className='pt-4 flex justify-between gap-2 items-center'>
        <h6 className='font-medium text-gray-6 text-sm'> {item.brandName} </h6>
        <ArrowUpIcon
          onClick={() => setIsOpen(!isOpen)}
          className={`cursor-pointer hover:bg-gray-border p-1 w-4 h-4 transition-all duration-100 ${
            !isOpen ? 'rotate-180' : ''
          }`}
        />
      </div>

      {isOpen && (
        <div className='pt-3 text-sm'>
          <div className='space-y-3 pt-[3px]'>
            {item.meals.map((itm, idx) => {
              return (
                <div key={idx}>
                  <div className='flex gap-2 items-center'>
                    <p className='text-[9px] text-gray-5 border border-gray-border rounded-full w-[22px] h-[22px] flex justify-center items-center'>
                      x{itm.quantity}
                    </p>
                    <p>{itm.name}</p>
                  </div>
                  <div className='ml-[30px] pt-2'>
                    {itm?.addons?.map((itms, i) => {
                      return (
                        <label key={i} className='flex gap-2 items-center text-gray-5'>
                          <p>{itms.quantity}x</p>
                          <span>{itms.name}</span>
                        </label>
                      );
                    })}
                  </div>
                  {itm.order_note ? (
                    <p className='p-3 bg-gray-11 text-gray-8 rounded'>
                      <span className='text-gray-6'>Order note</span>: {itm.order_note}
                    </p>
                  ) : null}
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default MealAccordion;
